import cookie from 'cookie'
import { QWebChannel } from 'qwebchannel'

let cookies = null
const getCookie = key => {
  if (!cookies || __IS_DEVELOPMENT__) {
    cookies = cookie.parse(document.cookie)
  }
  return cookies[key]
}

/**
 * 判断是否为客户端
 */
export function isClient() {
  return !!getCookie('Client-Agent')
}

/**
 * 判断是否为 Pc 客户端
 */
export function isPcClient() {
  return !!getCookie('Client-Agent') && getCookie('Client-Agent').indexOf('LDClientWin') > -1
}

/**
 * 判断是否为 Mac 客户端
 */
export function isMacClient() {
  return !!getCookie('Client-Agent') && getCookie('Client-Agent').indexOf('LDClientMac') > -1
}

/**
 * 判断是否为 Linux 客户端
 */
export function isLinuxClient() {
  return !!getCookie('Client-Agent') && getCookie('Client-Agent').indexOf('LDClientLinux') > -1
}

/**
 * 运行
 *
 * @param action 方法名
 * @param params 方法参数
 *
 * @returns 运行结果
 */
export async function run({ action, params = '' }) {
  if (isLinuxClient()) {
    return new Promise(resolve => {
      // eslint-disable-next-line no-new
      new QWebChannel(window.qt.webChannelTransport, channel => {
        channel.objects.bound.jsToNative(action, params, resolve)
      })
    })
  }
  return window.jsToNative(action, params)
}

/**
 * 处理原始方法，增加检测
 *
 * @param options 选项
 *                minVer: 最小可运行版本
 * @param cb 原始方法
 *
 * @returns 处理后的方法
 */
export const wrap = ({ minVer }, cb) =>
  async function wrapper(args) {
    if (!isClient()) {
      return { error: Error('current environment is not client') }
    }
    if (isLinuxClient() && !window.qt) {
      return { error: Error('current environment does not support QWebChannel method') }
    }
    if (!isLinuxClient() && !window.jsToNative) {
      return { error: Error('current environment does not support jsToNative method') }
    }
    if (minVer !== '*') {
      // TODO:
      return { error: Error('current version does not support this method') }
    }
    try {
      return cb.call(this, args)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      return {
        error,
      }
    }
  }
